import src from "IMAGE";
export default { src, width: 2880, height: 264, blurWidth: 8, blurHeight: 1, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAIAAABsYngUAAAAI0lEQVR42mNoWdm49fD0XVcebr32fe/NHwdv/zh058fhOz8A3hMS/tu6siUAAAAASUVORK5CYII="};
